import { render, staticRenderFns } from "./ClassErrorList.vue?vue&type=template&id=feff3d1a&scoped=true"
import script from "./ClassErrorList.vue?vue&type=script&lang=js"
export * from "./ClassErrorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feff3d1a",
  null
  
)

export default component.exports